import React from 'react';
import { UserPlus, Wallet, Link2 } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { Reveal, SectionHead } from '../motion';
import { ActionLink, TICKMILL_REF_URL, COPY_URL } from './links';

const ICONS = [UserPlus, Wallet, Link2];

export default function Steps() {
  const { t } = useLang();
  const steps = t('dcapital.steps');
  const actions = [
    <ActionLink key="r" href={TICKMILL_REF_URL} label={t('dcapital.ctaRegister')} testId="dc-step-register-btn" />,
    null,
    <ActionLink key="c" href={COPY_URL} label={t('dcapital.ctaCopy')} testId="dc-step-copy-btn" />,
  ];

  return (
    <section id="how" className="py-24 sm:py-32 bg-[#111D36] border-y border-slate-800" data-testid="dc-steps">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead overline={t('dcapital.howOverline')} title={t('dcapital.howTitle')} />
        <Reveal delay={0.1}>
          <p className="mt-5 max-w-2xl text-slate-400 leading-relaxed" data-testid="dc-steps-sub">{t('dcapital.howSub')}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.12} className="h-full">
                <div data-testid={`dc-step-${i}`} className="relative h-full flex flex-col rounded-xl border border-slate-700/70 bg-[#1E293B] p-8 transition-all duration-300 hover:border-blue-500/50 hover:-translate-y-1.5">
                  <div className="flex items-center justify-between">
                    <span className="flex w-12 h-12 items-center justify-center rounded-lg bg-blue-500/10 border border-blue-500/30">
                      <Icon className="w-5 h-5 text-blue-300" />
                    </span>
                    <span className="font-display text-5xl text-slate-700/80">0{i + 1}</span>
                  </div>
                  <h3 className="mt-6 font-display text-xl text-white">{s.title}</h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed flex-1">{s.text}</p>
                  <p className="mt-5 text-[11px] font-semibold tracking-widest text-green-400 uppercase">{s.hint}</p>
                  {actions[i] && <div className="mt-6">{actions[i]}</div>}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
